// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"74":"5cfcf7a3","78":"2db3c545","338":"f50fb721","576":"3e8d214e","753":"83112084","773":"59a1173c","775":"4d1b94c3","814":"cdb83f4e","990":"487099ac"}[chunkId] + ".js";
};